// extracted by mini-css-extract-plugin
export default {"techBox":"TechBoxes_techBox__PzXOq"};